import React, { AnchorHTMLAttributes, HTMLAttributeAnchorTarget } from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

const getRelationship = (target?: HTMLAttributeAnchorTarget) => (
  target === '_blank' ? 'noopener noreferrer' : undefined
);

const withFullWidth = css`
  display: block;
  width: 100%;
`;

const withStyled = css`
  text-decoration: none;
`;

export const Link = styled.a<AnchorProperties>`
  ${({
    // eslint-disable-next-line @typescript-eslint/no-shadow
    styled,
  }) => styled && withStyled}
  ${({ fullWidth }) => fullWidth && withFullWidth}
  color: var(--black-high);
`;

const anchorPropertyTypes = {
  /** Sets a style for covering all the container */
  fullWidth: PropTypes.bool,
  /** Sets basic anchor style */
  styled: PropTypes.bool,
};

export type AnchorProperties = AnchorHTMLAttributes<HTMLAnchorElement>
& InferProps<typeof anchorPropertyTypes>;

const Anchor = React.forwardRef<HTMLAnchorElement, AnchorProperties>(
  ({
    target,
    rel: relationship = getRelationship(target),
    ...properties
  }, reference) => (
    <Link
      target={target}
      rel={relationship}
      ref={reference}
      {...properties}
    />
  ),
);

Anchor.propTypes = anchorPropertyTypes;

Anchor.displayName = 'Anchor';

export default Anchor;
